<div class="topology-layout" [class.readonly-topology]="readonlyMode" [class.readonly-layout]="readonlyMode">
  <div class="topology-side-panel" *ngIf="!readonlyMode">
    <div class="cake-groups-section">
      <div class="cake-groups-header">
        <div class="cake-groups-title">Groups</div>
        <button type="button" class="cake-add-button" (click)="addCakeGroup()" [disabled]="cakeGroups.length >= maxCakeGroups">Add group</button>
      </div>

      <div class="cake-group-list">
        <div class="cake-group-item" *ngFor="let group of cakeGroups; trackBy: trackCakeGroup" [class.selected-group]="group.id === selectedCakeGroupId" (click)="selectCakeGroup(group.id)">
          <div class="cake-group-field">
            <span class="cake-group-swatch" [style.backgroundColor]="getGroupColorForGroup(group.id)"></span>
            <input type="text" class="cake-group-input" [(ngModel)]="group.name" [attr.maxlength]="maxGroupNameLength" (blur)="normalizeCakeGroupName(group)" (click)="$event.stopPropagation()" />
          </div>

          <button type="button" class="cake-remove-button" (click)="$event.stopPropagation(); removeCakeGroup(group.id)" [disabled]="cakeGroups.length <= 1">Delete</button>
        </div>
      </div>
    </div>
  </div>

  <div class="topology-card" [style.--group-color]="getSelectedGroupColor()">
    <div class="topology-main-panel">
      <div class="topology-main-header">
        <span class="topology-main-title">Topology</span>
        <span class="topology-main-group">{{ getSelectedCakeGroupName() }}</span>
      </div>
      <app-ef-cake-topology-structure
        [readonlyMode]="readonlyMode"
        sizeVariant="mid"
        [groupColor]="getSelectedGroupColor()"
        [nodeNames]="nodeNames"
        [activeEdges]="activeEdges"
        [activeStatusNodes]="activeStatusNodes"
        [bidirectionalEdgeDirections]="bidirectionalEdgeDirections"
        (singleDirectionEdgeToggle)="toggleSingleDirectionEdge($event)"
        (bidirectionalEdgeToggle)="toggleBidirectionalEdge($event)"
        (statusNodeToggle)="toggleStatusNode($event)">
      </app-ef-cake-topology-structure>
    </div>
  </div>

  <div class="topology-grid-card" *ngIf="!readonlyMode">
    <div class="topology-grid-title"></div>
    <table class="topology-grid" aria-label="Editable topology node names">
      <thead>
        <tr>
          <th>Key</th>
          <th>Name</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let nodeKey of topologyNodeKeys">
          <td class="grid-key">{{ nodeKey }}</td>
          <td>
            <input type="text" class="grid-input" [(ngModel)]="nodeNames[nodeKey]" [attr.aria-label]="'Name for ' + nodeKey" [attr.maxlength]="maxNodeNameLength" (blur)="normalizeNodeName(nodeKey)" (keydown.enter)="normalizeNodeName(nodeKey)" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
